import { useLocation } from "@madmedical/routing";
import useAppConfig from "./useAppConfig";
export default () => {
    const { basePath } = useAppConfig();
    const { pathname } = useLocation();
    return pathname.startsWith(basePath);
};
